import Styles from '@/styles/base/_color.scss'

function getColor(reference) {
  if (reference.onModel === 'Project') return Styles.primary

  switch (reference.ref.status) {
    case 'sale':
      return Styles.success
    case 'sold':
      return Styles.error
    case 'reserved':
      return Styles.reserved
    default:
      return '#999999'
  }
}

function Nest(items) {
  let mapping = items.reduce((res, cur, i, source) => {
    let children = source.filter(s => s.parent && s.parent.id === cur.id)
    if (children.length) res[cur.id] = children

    return res
  }, {})

  let roots = items.filter(f => !f.parent).sort((a, b) => (a.isEntry && !b.isEntry ? -1 : 0))

  const build = (items, level = 0) => {
    let arr = []
    items.forEach(item => {
      arr.push({ ...item, level })
      if (mapping[item.id]) arr.push(...build(mapping[item.id], level + 1))
    })

    return arr
  }

  return build(roots)
}

export { getColor, Nest }
